"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports._validator = exports.initialErrorStatus = void 0;
const is_empty_1 = require("utils/is-empty");
exports.initialErrorStatus = {
    ticket_no: { status: false, message: 'Required' },
    contractor_name: { status: false, message: 'Required' },
    hauler_no: { status: false, message: 'Required' },
    vessel_1: { status: false, message: 'Required' },
    vessel_2: { status: false, message: 'Required' },
    driver: { status: false, message: 'Required' },
    gate_in: { status: false, message: 'Required' },
    capacity_volume_1: { status: false, message: 'Required' },
    capacity_volume_2: { status: false, message: 'Required' },
};
const _validator = (arg) => __awaiter(void 0, void 0, void 0, function* () {
    let validate = {
        isError: false,
        data: exports.initialErrorStatus
    };
    try {
        if ((0, is_empty_1.isEmpty)(arg.ticket_no)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { ticket_no: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.contractor_name)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { contractor_name: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.hauler_no)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { hauler_no: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.vessel_1)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { vessel_1: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.vessel_2)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { vessel_2: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.driver)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { driver: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.gate_in)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { gate_in: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.capacity_volume_1)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { capacity_volume_1: { status: true, message: 'Required' } })
            };
        }
        if ((0, is_empty_1.isEmpty)(arg.capacity_volume_2)) {
            validate = {
                isError: true,
                data: Object.assign(Object.assign({}, validate.data), { capacity_volume_2: { status: true, message: 'Required' } })
            };
        }
        return validate;
    }
    catch (error) {
        return {
            isError: false,
            data: exports.initialErrorStatus
        };
    }
});
exports._validator = _validator;
